module.exports = __webpack_public_path__ + "static/media/ic_refresh.ca0ff28e.svg";